import React from "react";
import "../index.css";

const LOGO_DAI = "/dailogo_lg.png";

function LoginPage({ handleLogin }) {
  return (
    <div className="login-container">
      <div className="login-card">

        <div className="login-logoRow">
          <img src={LOGO_DAI} alt="DAI" className="login-logoSmall" />
        </div>

        <h2 className="login-title">Pricing Module Application</h2>

        <p className="login-subtitle">
          Please sign in to continue
        </p>

        <button onClick={handleLogin} className="login-button">
          Login with Microsoft
        </button>

      </div>
    </div>
  );
}

export default LoginPage;